import { createSelector } from 'redux-orm';

import orm from '../orm';
import { isLocalId } from '../utils/local-id';

export const makeAttachmentsByModelIdSelector = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ DeviceModel, Attachment }, id) => {
      const modelModel = DeviceModel.withId(id);

      if (!modelModel) {
        return modelModel;
      }

      let attachmentRefArray = modelModel.getOrderedAttachmentsQuerySet().toRefArray();
      if (modelModel.coverAttachmentId) {
        const attachmentModel = Attachment.withId(modelModel.coverAttachmentId);
        if (
          attachmentModel &&
          !attachmentRefArray.find((p) => p.id === modelModel.coverAttachmentId)
        ) {
          attachmentRefArray = attachmentRefArray.concat([attachmentModel.ref]);
        }
      }

      return attachmentRefArray.map((attachment) => ({
        ...attachment,
        isCover: attachment.id === modelModel.coverAttachmentId,
        isPersisted: !isLocalId(attachment.id),
      }));
    },
  );

export const attachmentsByModelIdSelector = makeAttachmentsByModelIdSelector();

export const makeCoverAttachmentByModelIdSelector = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ DeviceModel, Attachment }, id) => {
      const modelModel = DeviceModel.withId(id);

      if (!modelModel) {
        return modelModel;
      }

      let attachmentModel;
      if (modelModel.coverAttachmentId) {
        attachmentModel = Attachment.withId(modelModel.coverAttachmentId);
      }

      return attachmentModel?.ref;
    },
  );

export const coverAttachmentByModelIdSelector = makeCoverAttachmentByModelIdSelector();

export const attachmentsSelector = createSelector(orm, ({ Attachment }) =>
  Attachment.all().toRefArray(),
);
